import * as React from 'react'
import { useLocale, useTranslation } from 'hooks'
import * as S from './ProductActions.styles'

const ProductActions: React.FC<ProductActionsProps> = ({
  slug,
  isWalletPaymentOn,
  inStock,
  handleAddToCart,
  walletPaymentElement,
  showStockNotifyBtn,
  styleCode
}) => {
  const { t } = useTranslation()
  const { localiseUrl } = useLocale()

  return (
    <S.ProductActions id="product-actions">
      {inStock && (
        <S.ProductActionsButtonGroup>
          <S.ProductActionsButton
            variant="primary"
            fullWidth
            onClick={handleAddToCart}
          >
            {t('shared.add_to_cart')}
          </S.ProductActionsButton>

          {isWalletPaymentOn ? walletPaymentElement : null}
        </S.ProductActionsButtonGroup>
      )}
      <S.ProductActionsButton
        variant="secondary"
        fullWidth
        onClick={() =>
          (location.href = localiseUrl(
            `/account/selling/new?style_codes=${styleCode}`
          ))
        }
      >
        {t('react_components.product.sell_this_item')}
      </S.ProductActionsButton>
      {/* TODO: removing for now as its affecting data in google merchant centre,
       * we should think of a long term solution where option for stock notification only shows when certain size is unavailable
       */}
      {!inStock && showStockNotifyBtn && (
        <S.ProductActionsButton
          variant="tertiary"
          fullWidth
          onClick={() =>
            (location.href = localiseUrl(
              `/products/${slug}/stock-notification`
            ))
          }
        >
          {t('react_components.product.size_notification')}
        </S.ProductActionsButton>
      )}
    </S.ProductActions>
  )
}

interface ProductActionsProps {
  slug: string
  isWalletPaymentOn: boolean
  inStock: number | ''
  handleAddToCart: () => void
  walletPaymentElement: React.ReactNode
  showStockNotifyBtn: boolean
  styleCode: string
}

export default ProductActions
